import { render } from "./FpuiTableRow.vue?vue&type=template&id=b3395070"
import script from "./FpuiTableRow.vue?vue&type=script&lang=js"
export * from "./FpuiTableRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__